import { allowOnlyNumbers } from '@src/shared';

export const getPassportNumber = (passportSeriesAndNumber: string) => {
  return allowOnlyNumbers(passportSeriesAndNumber)?.substring(4, 10);
};
